import { render, staticRenderFns } from "./OrderApproval.vue?vue&type=template&id=3c5206a7&"
import script from "./OrderApproval.vue?vue&type=script&lang=js&"
export * from "./OrderApproval.vue?vue&type=script&lang=js&"
import style0 from "./OrderApproval.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports